import { Component, OnDestroy } from '@angular/core';
import { ContentfulService } from '../../_services/contentful.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../enviroments/environment';

@Component({
  selector: 'app-preview-toggle',
  standalone: false,
  templateUrl: './preview-toggle.component.html',
  styleUrl: './preview-toggle.component.css',
  template: `
    <div class="preview-mode" *ngIf="isPreview">
      🟢 Live Preview Mode
      <button (click)="exitPreview()">Exit Preview</button>
    </div>
  `  
})
export class PreviewToggleComponent {
  isPreview = false;
  private subscription!: Subscription;

  constructor(private contentful: ContentfulService) {


  }

}
